import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { CHAPTERS, WORKSHEETS } from "@/lib/content";

const Chapter = ({ c, open, onToggle }) => (
  <div className="border-b border-line" data-testid={`chapter-${c.n}`}>
    <button type="button" onClick={onToggle} aria-expanded={open} data-testid={`chapter-toggle-${c.n}`}
      className="group flex w-full items-start gap-5 py-6 text-left md:gap-8">
      <span className="font-display w-10 shrink-0 pt-1 text-sm text-zinc-500 transition-colors group-hover:text-white">{String(c.n).padStart(2, "0")}</span>
      <span className="flex-1">
        <span className="font-display block text-xl font-medium leading-snug text-white md:text-2xl">{c.title}</span>
        <span className="mt-1.5 block text-sm text-zinc-400 md:text-base">{c.outcome}</span>
      </span>
      <span className="hidden shrink-0 pt-1.5 text-xs uppercase tracking-widest text-zinc-400 sm:block">{c.lessons.length} lessons</span>
      <motion.span animate={{ rotate: open ? 45 : 0 }} className="shrink-0 pt-1 text-white"><Plus size={20} /></motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.ol initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden pl-[3.75rem] md:pl-[4.5rem]">
          {c.lessons.map((l, i) => (
            <li key={l} className="flex gap-4 pb-4 text-sm text-zinc-300 md:text-base last:pb-7">
              <span className="shrink-0 whitespace-nowrap text-zinc-500">Lesson {i + 1}</span>{l}
            </li>
          ))}
        </motion.ol>
      )}
    </AnimatePresence>
  </div>
);

export const ChapterList = () => {
  const [open, setOpen] = useState(2);
  return (
    <div className="border-t border-white/80" data-testid="chapter-list">
      {CHAPTERS.map((c) => <Chapter key={c.n} c={c} open={open === c.n} onToggle={() => setOpen(open === c.n ? 0 : c.n)} />)}
    </div>
  );
};

export const WorksheetList = () => {
  let k = 0;
  return (
    <div className="grid gap-x-10 gap-y-12 md:grid-cols-2" data-testid="worksheet-list">
      {WORKSHEETS.map((g, gi) => (
        <Reveal key={g.phase} delay={gi * 0.06}>
          <p className="eyebrow border-b border-white/80 pb-3">{g.phase}</p>
          <ul>
            {g.items.map((w) => {
              k += 1;
              return (
                <li key={w.title} className="group flex gap-5 border-b border-line py-5">
                  <span className="font-display w-8 shrink-0 text-sm text-zinc-500 transition-colors group-hover:text-cta">{String(k).padStart(2, "0")}</span>
                  <span>
                    <span className="font-display block text-lg text-white">{w.title}</span>
                    <span className="mt-1 block text-sm text-zinc-400">{w.text}</span>
                  </span>
                </li>
              );
            })}
          </ul>
        </Reveal>
      ))}
    </div>
  );
};
